import logo from '../media/logo.svg';
import '../css/login.css';
import { useLanguage } from '../providers/preferenceProvider';
import { useToast } from '../providers/toastProvider';
import { getRegistration, confirmRegistration } from '../api/registration-api';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import Overlay from '../shared/overlays/termsOfService';

const Register = () => {
  const { t } = useLanguage();
  const { showToast, showLoading, hideLoading } = useToast();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const registrationId = urlParams.get('registrationId');
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!registrationId) {
      navigate('/');
      return;
    }

    getRegistration(registrationId)
      .then((response) => {
        if (response && response.data) {
          setEmail(response.data.email);
          setFirstname(response.data.firstname);
          setLastname(response.data.lastname);
        } else {
          navigate('/');
        }
      })
      .catch((error) => {
        console.error('Error fetching registration data:', error);
        navigate('/');
      });
  }, []);

  const handleRegister = (e) => {
    showLoading();
    e.preventDefault();

    const special = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/; // All special chars

    let message = '';

    if (!password) {
      showToast('You must fill in a password', 'error');
    }

    if (!password.match(special))
      message = 'Your password must contain a special character (!, @, #, %, ^, &, *...).';
    if (password.length < 8)
      message = 'Your password must be at least 8 characters long.';
    if (password.toLowerCase().includes(firstname.toLowerCase()))
      message = 'Your password cannot include your name.';
    if (password.toLowerCase().includes(lastname.toLowerCase()))
      message = 'Your password cannot include your name.';
    if (password.toLowerCase() === password)
      message = 'Your password must include an upper case character.';
    if (password.toUpperCase() === password)
      message = 'Your password must include a lower case character.';

    if (message !== '') {
      showToast(message, 'error');
      hideLoading();
      return;
    }

    if (password !== confirmPassword) {
      showToast(t.toast.password_mismatch, 'error');
      return;
    }

    confirmRegistration(registrationId, password)
      .then(() => {
        showToast(t.toast.register_complete.replace("{ph_name}", firstname + ' ' + lastname), 'success');
        navigate('/');
        hideLoading();
      }).catch((error) => {
        console.error('Error during registration:', error);
        hideLoading();
      });
  }

  return (
    <>
      <div>
        <main className="main-container">
          <div className="login-box">
            <div className="main-header">{t.register}</div>
            <div className="form-container">
              <div className="login-content">
                <div className="register-message">{t.register_message.replace("{ph_name}", firstname)}</div>
                <form className="login-form" onSubmit={handleRegister}>
                  <input type="text" value={email} readOnly />
                  <div className="relative w-full">
                    <input type={showPassword ? "text" : "password"}  placeholder={t.password + "..."} onChange={e => setPassword(e.target.value)} required />
                    <FontAwesomeIcon
                      icon={showPassword ? faEyeSlash : faEye}
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 cursor-pointer"
                      style={{ pointerEvents: 'auto' }}
                      tabIndex={0}
                      role="button"
                    />
                  </div>
                  <div className="relative w-full">
                    <input type={showConfirmPassword ? "text" : "password"} className="confirm-password" placeholder={t.confirm_password + "..."} onChange={e => setConfirmPassword(e.target.value)} required />
                    <FontAwesomeIcon
                      icon={showConfirmPassword ? faEyeSlash : faEye}
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 cursor-pointer"
                      style={{ pointerEvents: 'auto' }}
                      tabIndex={0}
                      role="button"
                    />
                  </div>
                  <div className="tos-wrapper">
                    <input type="checkbox" name="agreeToTos" required />
                    <span>
                      I agree to the <p onClick={() => setIsOpen(true)} className="link">Terms of Service</p>
                    </span>
                  </div>
                  <button type="submit">{t.register}</button>
                </form>
              </div>
              <div className="login-logo">
                <img src={logo} alt="42Workspace" />
              </div>
            </div>
          </div>
        </main>
      </div>

      <Overlay
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

export default Register;
